import React, { useMemo } from "react";
import { useDispatch } from "react-redux";
import posthog from "posthog-js";

import { Button } from "@components/common";
import { addToCart, updateCartItem } from "@store/cart";
import { getOptimalUpsell } from "@helpers/cart/getOptimalUpsell";
import { Product } from "@typings/product/product";
import getProductDefaultConfiguration from "@helpers/products/getProductDefaultConfiguration";

interface UpgradeButtonProps {
  cartItems: Product[];
}

const UpgradeButton: React.FC<UpgradeButtonProps> = ({ cartItems }) => {
  const dispatch = useDispatch();

  const optimalUpsell = useMemo(() => getOptimalUpsell(cartItems), [cartItems]);

  if (!optimalUpsell) {
    return null;
  }

  const handleUpgrade = () => {
    if (optimalUpsell.isUpgrade) {
      const existingItem = cartItems.find((ci) => ci.item.id === optimalUpsell.item.id);

      if (existingItem && existingItem.configuration.quantity === 1) {
        const threeJarVariant = existingItem.item.variants.find(
          (v) =>
            v.name.toLowerCase().includes("3") && v.offerId === existingItem.configuration.offer.id
        );

        if (threeJarVariant) {
          const newConfiguration = getProductDefaultConfiguration(
            existingItem.item,
            undefined,
            undefined,
            threeJarVariant.name
          );

          const updatedCartItem = {
            ...existingItem,
            configuration: newConfiguration,
          };

          dispatch(updateCartItem({ oldItem: existingItem, newItem: updatedCartItem }));

          if (optimalUpsell.additionalUpsell) {
            const additionalCartItem = {
              item: optimalUpsell.additionalUpsell.item,
              configuration: getProductDefaultConfiguration(optimalUpsell.additionalUpsell.item),
            };

            dispatch(addToCart({ cartItems: [additionalCartItem] }));
          }
        }
      }
    } else {
      // This is adding a new upsell item
      const cartItem = {
        item: optimalUpsell.item,
        configuration: getProductDefaultConfiguration(optimalUpsell.item),
      };

      dispatch(addToCart({ cartItems: [cartItem] }));
    }

    if (typeof window !== "undefined") {
      posthog.capture("Upgrade button clicked", {
        product_id: optimalUpsell.item.id,
        product_name: optimalUpsell.item.name,
        variant: optimalUpsell.variant.name,
        gift_target: optimalUpsell.giftTarget,
        amount_needed: optimalUpsell.amountNeeded,
        is_upgrade: optimalUpsell.isUpgrade,
        has_additional_upsell: !!optimalUpsell.additionalUpsell,
      });
    }
  };

  return (
    <div className="upgrade-button-container">
      <Button onClick={handleUpgrade} className="upgrade-button" size="large">
        🔥 Tap to Upgrade & Unlock Your <br /> {optimalUpsell.giftTarget}
      </Button>
      {/* <div className="upgrade-button-details">
        <span className="upgrade-price">
          Add {optimalUpsell.variant.name} for ${optimalUpsell.variant.price}
        </span>
        <span className="upgrade-gift">→ {optimalUpsell.giftTarget} unlocked</span>
      </div> */}
    </div>
  );
};

export default UpgradeButton;
